import styled, { css } from 'styled-components';
import { colors } from 'globalStyles';
import { media } from 'utils/style-utils'

export const DeviceWrapper = styled.div`
  ${({ shrink }) => shrink && `
    float: left;
    zoom: 0.7586206896551724;
    -moz-transform: scale(0.7586206896551724);
    transform-origin: left;
  `}

  ${ media.mobile`
    margin-bottom: 20px;
    transform-origin: center;
  `}

`;

export const ValidIndicatorContainer = styled.div`
  position: relative;
`;

export const ValidIndicator = styled.div`
  position: absolute;
  top: 14px;
  right: 10px;

  ${media.mobile`
    top: 1em;
    right: 2.7em;
  `}
  `;

export const DeviceTextWrapper = styled.div`
  position: relative;
  top: 50%;
  transform: translateY(-50%);
  display: flex;
  flex-direction: column;
  align-items: center;
`;

export const StyledDeviceText = styled.div`
  color: ${colors.WHITE};
  text-align: center;
  white-space: nowrap;

  ${({ font, maxWidth, fontSize, lineHeight, letterSpacing }) => `
    width: ${maxWidth}px;
    font-family: ${font};
    font-size: ${fontSize}px;
    font-weight: normal;
    line-height: ${lineHeight}%;
    letter-spacing: ${letterSpacing}px;
  `}
`;

export const StyledFilterPreview = styled.div`
  position: relative;
  width: 300px;
  display: flex;
  align-items: center;
  margin-left: 28px;
  ${({ small }) => small && `
    float: left;
    zoom: 0.6;
    -moz-transform: scale(0.6);
    -moz-transform-origin: -212px;
  `}
  ${ media.mobile`
   -moz-transform-origin: center;
  `}
  ${({ med }) => med && `
    margin: ${20/0.7326732673267327}px ${20/0.7326732673267327}px 0 0;
    zoom: 0.7966666667;
    -moz-transform: scale(0.7966666667);
  `}

  ${({ noMargin }) => noMargin && `
    margin: 0px;
  `}

  ${({ center }) => center && `
    display: flex;
    justify-content: center;
  `}
`;

export const FilterPreviewShadow = styled.div`
  height: 30px;
  box-shadow: 0 0 27px 0 #000000;
  position: absolute;
  z-index: 0;
  top: 50%;
  margin-top: 160px;
  width: calc(100% - 75px);
  left: 50%;
  margin-left: calc(-1* (100% - 75px) /2);
`;

export const ThemesWrapper = styled.form`
  display: grid;
  margin-top: 56px;
  grid-column-gap: 20px;
  grid-template-columns: 460px 460px;

  ${ media.mobile_and_tablet`
    grid-template-columns: 100%;
  `}

  ${ media.mobile`
    margin-top: 40px;
  `}

  ${ media.desktop`
    grid-template-columns: 100%;
  `}
`;

export const ThemeFieldWrapper = styled.label`
  height: 350px;
  width: 460px;
  padding: 25px;
  display: flex;
  align-items: center;
  border: 1px solid transparent;
  border-radius: 3px;
  cursor: pointer;

  &:hover {
    border: 1px solid ${colors.MAIN_COLOR};
  }

  ${({ selected }) => selected && `
    border: 1px solid ${colors.MAIN_COLOR};
  `}

  > input {
    display: none;
  }

  ${ media.mobile_and_tablet`
    height: inherit;
    padding: 20px 30px;
  `}

  ${ media.mobile`
    flex-direction: column;
    align-items: center;
    width: 100%;

  `}
`;

export const PreviewFilter = styled.div`
  height: 404px;
  width: 300px;
  display: flex;
  flex-direction: column;
  align-items: center;
  position: relative;
  z-index: 1;
  ${({ width, height}) => `
    width: ${width|300}px;
    height: ${height|404}px;
  `}
`;

export const PreviewFilterLogoWrapper = styled.div`
  position: absolute;
  bottom: 0;

  ${({ isBehindText }) => isBehindText && `
    bottom: 15.75px;
  `
  }
`;

const afterIndicator = css`
  content: '';
  display: block;
  position: relative;
  left: 6px;
  width: 4px;
  height: 12px;
  border-width: 0 2px 2px 0;
  transform: rotate(45deg);
`;
export const marginOfDisbaledFields = css`
  margin: 10px;
`;
export const inputIndicatorStyles = css`
  width: 20px;
  height: 20px;
  border: solid 1px ${colors.LIGHT_GRAY};
  border-radius: 3px;
  transition: .1s;

  ${({ selected }) =>
    selected
      ? `
        background-color: ${colors.GREEN};
        border: solid 1px ${colors.GREEN};

        &:after {
          border: solid ${colors.WHITE};
          ${afterIndicator}
        }`
      :`
      label:hover &:after {
          border: solid ${colors.LIGHT_GRAY};
          ${afterIndicator}
        }
  `}
`;

export const InputIndicator = styled.div`
  ${inputIndicatorStyles}
`;

export const OptionsInputIndicator = styled.div`
  ${inputIndicatorStyles}
  margin: 14px 10px 0 20px;
`;

export const ThemeInputIndicator = styled.div`
  ${inputIndicatorStyles}

  position: absolute;
  right: 0;
  margin: 166px 20px;
`;

export const DisabledTabWrapper = styled.div`
  padding-top: 60px;
  text-align: center;
  > button {
    font-size: 14px;
  }
`;

export const GifStyleWrapper = styled.div`
  display: flex;
  flex-wrap: wrap;
  margin-top: 20px;

`;

export const PhotoFilterWrapper = styled.div`
  display: flex;
  ${ media.desktop`
    justify-content: space-between;
  `}
  ${ media.tablet`
    justify-content: space-between;
  `}
  > * {
    width: 50%;
    display:flex;
    justify-content: center;
    ${ media.desktop`
      width: 237px;

      &:first-child {
        margin-left: 20px;
      }
    `}

    ${ media.tablet`
      width: 246px;
      &:first-child {
        margin-left: 36px;
      }
    `}
  }
`;

export const AppPreviewWrapper = styled.div`
  margin-right: 20px;
`;

export const PhotoFilterFieldWrapper = styled.div`
  display: flex;
  flex-direction: column;
  justify-content: flex-start;
  align-items: center;
  margin-top: 20px;

`;

export const GifStyleFieldLabel = styled.label`
  color: ${colors.MEDIUM_GRAY};
  font-size: 10px;
  font-weight: bold;
  width: 25%;
  border: 1px solid rgba(0,0,0,0);
  padding: 17px;
  &:hover,
  &.selected {
    cursor: pointer;
    border: 1px solid ${colors.GREEN};
    border-radius: 8px;
  }

  > div {
    width: 100%;

    div:first-child {
      width: 100%;
    }
  }

  ${ media.desktop`
    width: calc(50% - 12.5px);
  `}

  ${ media.tablet`
    width: calc(50% - 5.5px);
  `}

  ${ media.mobile`
    width: 50%;
  `}

  ${ media.mobile_500`
    width: 100%;
  `}
`;

export const RadioInputWrapper = styled.div`
  display: flex;
  justify-content: space-between;
  align-items: center;
  padding-top: 10px;

  .radio-input-container {
    display: flex:
    align-items: flex-start;
  }

  label {
    font-size: 14px;
    line-height: 15px;
    font-weight: normal;
    color: ${colors.BODY}
    margin-left: 10px;
  }

  input[type="radio"] {
    background-color: white;
    border-radius: 10px;
    border: 1px solid;
    cursor: pointer;
    display: inline-block;
    height: 14px;
    margin-top: 0;
    position: relative;
    width: 14px;
    -webkit-appearance: none;
  }
  input[type="radio"]:checked {
    border-color: ${colors.MAIN_COLOR};
    &:after {
      background-color: ${colors.MAIN_COLOR};
    }
  }
  input[type="radio"]:after {
      background-color: white;
      border-radius: 25px;
      content: '';
      display: block;
      height: 8px;
      left: 2px;
      position: relative;
      top: 2px;
      width: 8px;
  }
`;

export const PhotoOptionsWrapper = styled.div`
  > div + div {
    margin-top: 20px;
  }
`;

export const LogoWrapper = styled.div`
  width: 208.313px;
  height: 116.43px;
  z-index: 1;

  ${({ isAppLogo }) => isAppLogo && `
    margin: 0px auto 13px;
    width: 208.313px;
    height: 116.43px;
  `}
`;

export const GifStyleFieldLabelText = styled.div`
  display: flex;
  align-items: flex-end;
  align-self: center;
`;

export const StyledForm = styled.form`
  padding-bottom: 250px;
  margin-top: 10px;

  .right-pos {
    float: right;
  }

  .left-pos {
    float: left;
  }

  .branding-form-group {
    ${ media.mobile`
      border-bottom: 0;
    `}
  }

  .pdd-20 {
    padding-top: 20px;
  }

  &.basic-info-form {
    margin-top: 36px;

    ${ media.mobile`
      margin-top: 26px;
    `}

    .channel-forms__group {
      text-align: right;
      button {
      ${ media.mobile`
          margin-top: 20px;
      `}
      ${ media.tablet`
          margin-top: 0px;
      `}
      ${ media.desktop`
          margin-top: 0px;
      `}
      }
    }
    .channel-forms__basic-info-event-time-zone-label {
      text-transform: uppercase;
      position: absolute;
      padding: 0 10px;
      margin: -7px 10px;
      font-size: 9px;
      font-weight: bold;
      line-height: 13px;
      margin-top: 13px;
      letter-spacing: 2px;
      color: #91ADBA;
      z-index: 1;
      background-color: #FFFFFF;
    }
      .timezone-picker{
        border-radius: 2px;
        width: 100%;
        margin-top: 17px;
      }
      .timezone-picker-open{
        border: 1px solid #007AFF;
        border-radius: 2px;
      }
      .timezone-picker-textfield input{
        width: 100%;
        height: 48px;
        padding: 9px 20px;
        font-size: 14px;
        font-family: neue-haas-unica, sans-serif;
        border-box; outline:
        background-color: inherit;
        border:1px solid #e6ebec;
        border-radius: 2px;
        color: #36474F;
    }
    .Select-placeholder,
    .Select--single > .Select-control .Select-value {
    bottom: 0;
    color: #aaa;
    left: 0;
    line-height: 43px;
    padding-left: 10px;
    padding-right: 10px;
    position: absolute;
    right: 0;
    top: 0;
    max-width: 100%;
    overflow: hidden;
    text-overflow: ellipsis;
    white-space: nowrap;
  }
    .Select-menu-outer {
      border-bottom-right-radius: 4px;
      border-bottom-left-radius: 4px;
      background-color: #fff;
      border: 1px solid #ccc;
      border-top-color: #e6e6e6;
      box-shadow: 0 1px 0 rgba(0, 0, 0, 0.06);
      box-sizing: border-box;
      margin-top: -1px;
      max-height: 200px;
      position: absolute;
      left: 0;
      border: 1px solid #007AFF;
      top: 100%;
      width: 100%;
      z-index: 1;
      -webkit-overflow-scrolling: touch;
    }
    .Select-control {
      background-color: #fff;
      border-color: #d9d9d9 #ccc #b3b3b3;
      border-radius: 4px;
      border: 1px solid #ccc;
      color: #333;
      cursor: default;
      display: table;
      border-spacing: 0;
      border-collapse: separate;
      height: 48px;
      outline: none;
      overflow: hidden;
      position: relative;
      width: 100%;
      margin-top: 20px;
      margin-bottom: 20px
    }
    .Select.is-focused > .Select-control {
      border: 1px solid #007AFF;
      background: #fff;
    }
    .fourteen-px {
      font-size: 14px;
    }
    > div {
      ${ media.mobile`
        width: 100%;
        .tooltip {
          right: 5px;
        }
        input { 
          width: calc(100% - 30px);
        }
        input[type="radio"] { 
          width: 14px;
        }
        .display_block { 
          button {
            margin: -30px -23px;
          }
        }
      `}
    }

`;

export const FormGroupWithoutBorderBottom = styled.div `
  margin-top: -2px;
  width: 100%;
  display: inline-block;
  border-top: 1px solid ${colors.LIGHT_GRAY};
  > &:last-child {
    border-bottom: none;
  }
  > em {
      display: inline-block;
      text-transform: uppercase;
      position: absolute;
      padding: 0 10px;
      margin: -54px 10px;
      font-size: 9px;
      font-weight: bold;
      line-height: 13px;
      letter-spacing: 2px;
      color: #91ADBA;
      z-index: 1;
      background-color: #FFFFFF;
  }
  .channel-forms__diabled-checkboxes {
    opacity: 0.2;
    background-color: #91ADBA;
  }

  &.customization-type {
    height: 100px;
    margin-bottom: 20px;
    border-bottom: 1px solid ${colors.LIGHT_GRAY};
  }
`;

export const FormGroup = styled.div`
  > &:last-child {
    border-bottom: none;
  }
  > em {
      display: inline-block;
      text-transform: uppercase;
      position: absolute;
      padding: 0 10px;
      margin: -54px 10px;
      font-size: 9px;
      font-weight: bold;
      line-height: 13px;
      letter-spacing: 2px;
			color: #91ADBA;
      z-index: 1;
      background-color: #FFFFFF;
  }
  .channel-forms__diabled-checkboxes {
    opacity: 0.2;
    background-color: #91ADBA;
  }
  &.sharing-form {
    display: flex;
    padding-bottom: 15px;
    > div {
      ${media.mobile`
        width: 100%;
      `}
    }
  }
`;
export const FieldHead = styled.div `
  width: 100%;
  padding-top: 17px;

  position: relative;
  z-index: 1000;
  > div:first-child{
    padding-top: 0px;
    padding-left: 16px;
    float :left;

  }
  > div {
    float: right;
    width: 50%;
    padding-top: 21px;
    padding-right: 17px;
    > strong {
      display: block;
      color: #91ADBA;
      font-size: 8px;
      font-weight: 900;
      line-height: 13px;
      text-transform: uppercase;
      letter-spacing: 2px;
      margin: 0 0 7px;
      width: 180px;
    }
    > h3 {
      width: 800px;
      color: #36474F;
      font-size: 14px;
      line-height: 21px;
      font-weight: 400;
      margin: 0 0 22px;
      ${media.mobile_and_tablet`
        width: 100%;
      `}

      a {
        color: ${colors.MAIN_COLOR};
        text-decoration: underline;
      }
    }
    > span {
      opacity: 0.2;
      color: #36474F;
      font-size: 12px;
      line-height: 18px;
      margin: 0 0 25px;
      display: block;
    }
  }
  &.brand {
    > strong {
      display: block;
      color: black;
      font-size: 16px;
      font-weight: bold;
      line-height: 24px;
      letter-spacing: -0.5px;
      margin: 0;
      font-family: Poppins;
    }
    > h3 {
      color: #36474F;
      font-size: 12px;
      line-height: 18px;
      font-weight: 400;
      margin: 0 0 22px;
      ${media.mobile`
        width: 100%;
      `}

      &.disabled {
        margin: 0;
      }
    }
  }
  &.sharing-field {
    display: flex;
    justify-content: space-between;
    border-bottom: 1px solid ${colors.GRAY};

     > div:first-child {
      > h3 {
        margin: 0 0 12px 0;
      }
     }
     > div:nth-child(1) {
      width: 80%;
    }
     > div:nth-child(2) {
       padding-top: 19px;
       width: 100px;
     }
  }
  &.tooltip {
    display: flex;
    justify-content: space-between;
    > div:nth-child(2) {
      width: auto;
      padding: 0;

       > span {
        opacity: inherit;
        color: white;
        font-size: inherit;
        line-height: inherit;
        margin: inherit;
        display: inherit;
       }
    }
  }
`;
export const SmallField = styled.div `
   width: 460px;
    ${ media.mobile`
      width: 100%;
  `}
`;

export const DraggableImageContainer = styled.ul`
  padding: 0;
  li {
    width: 100%;
    height: 47px;
    display: flex;
    justify-content: space-between;
    align-items: center;
  }
`;

export const ImageOption = styled.div`
  padding: 10px 20px;
  cursor: pointer;
  width: 100px;
  ${({ selected }) => selected && `background-color: ${colors.LIGHT_BLUE};`}

  &:hover {
    background-color: ${colors.LIGHT_GRAY}80;
  }

  > div {
    background-repeat: no-repeat, no-repeat;
    background-size: contain, cover;
    width: 100%;
    height: 100px;
    overflow: hidden;
  }
`;

export const CenterDiv = styled.div`
  text-align: center;

  &.pdd-top {
    padding-top: 40px;
  }
`;

export const UpgradeText = styled.div`
  color: ${colors.MAIN_COLOR};
  text-decoration: underline;
  font-size: 13px;
  letter-spacing: 0.5px;

  &:hover {
    cursor: pointer;
    color: ${colors.MAIN_COLOR};
  }
`;

export const BrandingFormSection = styled.div`
  display: flex;
  ${media.mobile`
    display: block;
  `}
  .right-side {
    float: right;
    width: 50%;
    min-height: 420px;
    text-align: right;
    position: relative;
    >div {
      float: right;
    }

    .device {
      position: -webkit-sticky;
      position: sticky;
      top: 0;
    }

    ${media.mobile`
      width: 100%;
      border-bottom: solid 1px #E7EBEC;
      margin-bottom: 20px;
      > div {
        position: absolute!important;
        margin: 0;
        top: 50%!important;
        left: 50%;
        transform: translate(-50%, -50%);
      }
    `}
  }

  .left-side {
    float: left;
    width: 50%;

    ${media.mobile`
      float: inherit;
      width: 100%;
    `}
  }

  .upload-btn {
    >div {
      padding-top: 0;
    }
    label {
      border-radius: 15px;
      width: 128px;
      height: 32px;
      border: 1px solid ${colors.MAIN_COLOR};
      color: ${colors.MAIN_COLOR};
      padding: 6px 25px;
      font-size: 12px;
      background-color: transparent;
      line-height: 17px;
  
      &:hover {
        cursor: pointer;
        background-color: ${colors.MAIN_COLOR}16;
      }
    }
  }
`;

export const ChannelFormSection = styled.div `
  width: 50%;
  ${media.mobile`
    width: 100%;
  `}
  .brand {
    border-bottom: 1px solid ${colors.LIGHT_GRAY};
    > h3 {
      margin: 0 0 16px;
    }
  }
  .field-file {	
    padding: 0 0 16px 0;
  }
  .field-text {
    padding: 0;
    margin-top: 1em;
  }
`;

export const SharingRequiredField = styled.div`
  font-size: 11px;
  font-weight: 400;
  color: #36474F;
  padding: 0 0 10px 0;
  display: flex;

  > div {
    line-height: 14px;
    > label {
      input {
        &:checked + div {
          background-color: ${colors.MAIN_COLOR};
          border: solid 2px ${colors.MAIN_COLOR};
        }
      
        &:checked + div:after {
          left: 3px!important;
          width: 3px!important;
          height: 7px!important;
        }
      }
      > div {
        width: 14px;
        height: 14px;
        border: solid 1px ${colors.GRAY};
      }
    }
  }
`;

export const GroupRadioWrapper = styled.div`
  padding-left: 16px;
  > label {
    width: 800px;
    color: #36474F;
    font-size: 14px;
    line-height: 21px;
    font-weight: 400;
    margin-left: 16px;
  }

  input[type="radio"] {
    margin: 0;
    background-color: white;
    border-radius: 10px;
    border: 1px solid;
    cursor: pointer;
    display: inline-block;
    height: 14px;
    margin-bottom: -3px;
    position: relative;
    width: 14px;
    -webkit-appearance: none;
  }
  input[type="radio"]:checked {
    border-color: ${colors.MAIN_COLOR};
    &:after {
      background-color: ${colors.MAIN_COLOR};
    }
  }
  input[type="radio"]:after {
      background-color: white;
      border-radius: 25px;
      content: '';
      display: block;
      height: 8px;
      left: 2px;
      position: relative;
      top: 2px;
      width: 8px;
  }
`;

export const UpgradeButtonLinkContainer = styled.div`
  display: flex;
  width: 100%;
  justify-content: center;
  align-items: center;
  margin: 0 0;
  font-size: 13px;  
  text-decoration: underline;
  color: ${colors.MAIN_COLOR};  
  letter-spacing: 0.5px;
}`;

export const UpgradeButtonLink = styled.a`
  margin: 0;
  text-align: center;
  &:hover {
    cursor: pointer;
  }
`;

export const FilterToggleGroupContainer = styled.div`
margin-top: 1em;
`



// WEBPACK FOOTER //
// ./src/containers/ChannelsPage/Forms/styledComponents.js